import { Component, Input, OnInit } from '@angular/core';
import { LendersSolicitorService } from '../../shared/services/lenders-solicitor.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-lender-solicitor-details',
  templateUrl: './lender-solicitor-details.component.html',
  styleUrls: ['./lender-solicitor-details.component.scss']
})
export class LenderSolicitorDetailsComponent implements OnInit {

  @Input() lenderSolicitorId?: number;

  newLenderSol: boolean = true;
  updatingLenderSol: boolean = false;

  lenderSolDetails = this.fb.group({
    id: null,
    name: ['', Validators.required],
    addressLine1: [],
    addressLine2: [],
    addressLine3: [],
    addressLine4: [],
    addressLine5: [],
    postcode: [],
    isActive: [true]
  }, { });

  constructor(private fb: UntypedFormBuilder,
    private lenderSolservice: LendersSolicitorService,
    public activeModal: NgbActiveModal,
    private toastService: ToastService) {

  }

  ngOnInit(): void {
     if(this.lenderSolicitorId !== undefined && this.lenderSolicitorId !== null){
        this.newLenderSol = false;

        this.lenderSolservice.lenderSolDetails(this.lenderSolicitorId).subscribe(result => {
          this.lenderSolDetails.patchValue(result);
        });
      }
      else{
        this.lenderSolDetails.controls['isActive'].patchValue(true);
      }
  }

  saveLenderSol(){

    this.updatingLenderSol = true;

    this.lenderSolservice.updateLenderSol(this.lenderSolDetails.value).subscribe(response => {

      this.activeModal.close(true);
      this.updatingLenderSol = false;

      }, (error : any) => {

        var errorMessage = "Update Failed";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

        this.updatingLenderSol = false;
        this.toastService.error(errorMessage);


      });
  }

  addLenderSol(){
    this.lenderSolservice.addLenderSol(this.lenderSolDetails.value).subscribe(response => {

      this.activeModal.close(true);

      }, error => {

        var errorMessage = "Creation Failed";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

        this.toastService.error(errorMessage);
    });
  }

}
